import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/s/$token')({
  component: SigningSessionPage,
})

function SigningSessionPage() {
  const { token } = Route.useParams()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-2xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Public Signing Session
          </h1>
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Session Token:
            </p>
            <code className="text-sm font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100 break-all">
              {token}
            </code>
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            This is a placeholder for the public signing session page.
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            In production, this page will load the document signing interface
            for external users without requiring authentication.
          </p>
        </div>
      </div>
    </div>
  )
}
